import styles from "./QuestionPreview.module.less";
import React, {useContext, useEffect, useState} from "react";
import { Spin } from "antd";
import QuestionContent from "../questionnaire/js/questionContent";
import {contexData} from "../../store";
import axios from "../../utils/selfRequest";

const QuestionPreview = () => {
  const { dispatch } = useContext(contexData); //解构得到属性
  const [answer, setAnswer] = useState({});
  const [qData, setQData] = useState(
    JSON.parse(sessionStorage.getItem("questionPreview"))
  );

  useEffect(() => {
    const targetOrigin =
      {
        "devanswer.91question.com": "devpro.91question.com",
        "testanswer.91question.com": "testpro.91question.com",
        "answer.91question.com": "pro.91question.com",
        localhost: "localhost:3000",
      }[window.location.hostname] || "testpro.91question.com";
    window.addEventListener(
      "message",
      (event) => {
        if (!event.origin.includes(targetOrigin)) return;
        sessionStorage.setItem("questionPreview", JSON.stringify(event.data));
        (event.data.childs||[]).forEach(element => {
              if(!element.hide){
                element.hide=0
              }
        });
        setQData(event.data);
      },
      false
    );
    window.opener.postMessage(
      "questionPreviewPageLoaded",
      `${window.location.protocol}//${targetOrigin}`
    );
  }, []);
  useEffect(() => {
        if (qData && qData.surveyId) {
            axios.get(`answer/test/surveyInfo/${qData.surveyId}`).then((res) => {
                const indata = res.data || {};
                sessionStorage.setItem("internationalizeFlag", indata.language || "zh")
                dispatch({type: "init", data: indata});
            });
        }
    }, [qData]);
  console.log("qData", qData);
  return (
    <div className={styles.wrapper} style={{    padding: '0 36px'}}>
      <h1>问题预览页</h1>
      <Spin className={styles.content} spinning={!qData} size="large" >
        {qData && (
          <div style={{ }}>
            <QuestionContent
              info={qData}
              answer={answer}
              changeAnswer={(value) => {
                setAnswer((oldAnswer) => {
                  let newAnswer = { ...oldAnswer };
                  newAnswer = { [qData.id]: value };
                  return newAnswer;
                });
              }}
            />

          </div>

        )}
      </Spin>
    </div>
  );
};

export default QuestionPreview;
